
/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';

import {
    Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors, Field } from 'react-redux-form';

//import loadsStore from '../../../stores/loads-store';

import axios from 'axios';
import Select from 'react-select';
// import JmpModal from './customModal';
import ItemModal from './customModal';
import accountStore from '../../../stores/account-store';
import reportStore from '../../../stores/report-store';


class AddItem extends Component {

    constructor(props) {
        super(props);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            isModalOpen: false,
            Jumper_id: '',
            errors: '',
            amount: "",
            itemType: {},
            itemsSchedule:[],
            selectedItem:'',
            itemCount:1,
            displayCount:false,
        }
        this.amount = '';
    }

    toggleModal(e) {
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            amount: "",
            displayCount:false,
            itemCount:1,
            //jumpType: null
        });
    }

    componentWillMount() {
        var itemSchedule = reportStore.itemsSchedule;

        if(itemSchedule.length > 0) {
            this.setState({
                itemsSchedule:itemSchedule
            })
        }
        else {
            reportStore.loadPrices().then((res) => {
                this.setState({
                    itemsSchedule:res.itemsSchedule
                })
            })
        }
    }

    componentWillReceiveProps() {
        //alert(this.props.jumperId)
        this.setState({
            Jumper_id: this.props.jumperId
        })
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]:e.target.value
        })
    }

    handleCountChange = (e) => {
        const {selectedItem, itemsSchedule } = this.state;
        var count = e.target.value;
        var item = itemsSchedule.filter(x=> x.item === selectedItem)[0];

        var price = 0;
        if(item)
        {
            price= item.price.toFixed(2);
        }
        var totalAmount = (count * price).toFixed(2);
            
        this.setState({
            itemCount : count,
            amount: totalAmount
        })
    }

    handleSelect = (e) => {

        const { itemsSchedule,itemCount } = this.state;
        var value= e.target.value; 
        var count= false;

        if(value === "pack job" || value === "packing student credit" || value === "packing tandem credit")
        {
            count = true;
        }
        var item = itemsSchedule.filter(x=> x.item===e.target.value)[0];

        var price = 0;
        if(item)
        {
            price= item.price.toFixed(2);
        }
        var totalPrice = (price * itemCount).toFixed(2);

        this.setState({
            amount : totalPrice,
            displayCount : count,
            selectedItem:e.target.value
        })
        //console.log(price);
    }


    renderItems = () => {
        return this.state.itemsSchedule.map((val, index) => {
			return (
                <option>{val.item}</option>
			)
		})
    }

    handleSubmit(values, isTandemStudent) {
        var payload = {};
        var jumperId = this.props.jumperId;
        const {amount} = this.state;

        if (amount !== undefined && amount != "") {

            var check = amount.match(/((\d+)(\.\d{2}))$/);
            if (check != null) {

                payload.item = values.items;
                payload.price = amount;
                payload.count = this.state.itemCount;

                if(values.memo != "")
                {
                    payload.memo = values.memo;
                }
                //var count = values.count ? values.count : 1;
                //payload.price = amount * count;

                if (!isTandemStudent) {
                    accountStore.AddItem(jumperId, payload);
                }
                else {
                    accountStore.AddItemForTandemStudent(jumperId, payload);
                }
                this.toggleModal();
            }
            else {
                this.setState({
                    errors: "Amount should be enter in two decimal places"
                })
                setTimeout(() => {
                    this.setState({ errors: "" });
                }, 2000);
            }
        }
        else {
            this.setState({
                errors: "This field is required"
            })
            setTimeout(() => {
                this.setState({ errors: "" });
            }, 2000);
        }

    }


    // handleSubmit(values, isTandemStudent) {

    //     var payload = {};
    //     var jumperId = this.props.jumperId;
    //     const {amount} = this.state;
    //     if (values.amount !== undefined && values.amount != "") {

    //         var check = values.amount.match(/((\d+)(\.\d{2}))$/);
    //         if (check != null) {
    //             // payload.item = values.items.label;
    //             payload.item = values.items;

    //             var count = values.count ? values.count : 1;

    //             payload.price = values.amount * count;


    //             if (!isTandemStudent) {
    //                 accountStore.AddItem(jumperId, payload);
    //             }
    //             else {
    //                 accountStore.AddItemForTandemStudent(jumperId, payload);
    //             }
    //             this.toggleModal();
    //         }
    //         else {
    //             this.setState({
    //                 errors: "Amount should be enter in two decimal places"
    //             })
    //             setTimeout(() => {
    //                 this.setState({ errors: "" });
    //             }, 2000);
    //         }
    //     }
    //     else {
    //         this.setState({
    //             errors: "This field is required"
    //         })
    //         setTimeout(() => {
    //             this.setState({ errors: "" });
    //         }, 2000);
    //     }

    // }

    render() {
        const { displayCount,selectedItem } = this.state;
        var displayMemo = selectedItem ===  "adjustment" || selectedItem === "miscellaneous" ? true: false;
        return (
            <React.Fragment>
                <ItemModal
                    isModalOpen={this.state.isModalOpen}
                    title={`Add Item`}>
                    <LocalForm onSubmit={(values) => this.handleSubmit(values, this.props.isTandemStudent)}>

                        <Row className="form-group">
                            <Label htmlFor="items" md={4}>Item Name :</Label>
                            <Col md={8}>
                             
                                <Control.select model=".items" name="items"
                                    className="form-control" defaultValue="Select..."
                                    mapProps={{ onChange: (props) => props.onChange }}
                                    onChange= {this.handleSelect}
                                    ref="items"
                                >
                                    <option>select...</option>
                                    {/* <option>miscellaneous</option>
                                    <option>adjustment</option> */}
                                    {this.renderItems()}
                                    {/* <option>cafe</option>
                                    <option>reserve repack</option>
                                    <option>rigger</option>
                                    <option>miscellaneous</option>
                                    <option>miscellaneous rigging</option>
                                    <option>t-shirt</option>
                                    <option>helmet</option>
                                    <option>adjustment</option> */}
                                </Control.select>
                            </Col>
                        </Row>

                        { 
                            displayCount &&         
                            <Row className="form-group">
                                <Label htmlFor="count" md={4}>Enter Count : </Label>
                                <Col md={8}>
                                    <Control.input name="count" model=".count" className="form-control"
                                        mapProps={{ onChange: (props) => props.onChange }} autoComplete="off"
                                        value={this.state.itemCount}
                                        onChange={this.handleCountChange}
                                    />
                                </Col>
                            </Row>
                        }

                        { 
                           displayMemo &&         
                            <Row className="form-group">
                                <Label htmlFor="memo" md={4}>Enter Memo : </Label>
                                <Col md={8}>
                                    <Control.input name="memo" model=".memo" className="form-control"
                                        mapProps={{ onChange: (props) => props.onChange }} autoComplete="off"
                                    />
                                </Col>
                            </Row>
                        }    

                        <Row className="form-group">
                            <Label htmlFor="amount" md={4}>Enter Amount : </Label>
                            <Col md={8}>
                                <Control.input name="amount" model=".amount" className="form-control"
                                    mapProps={{ onChange: (props) => props.onChange }} autoComplete="off"
                                    value={this.state.amount}
                                    onChange={this.handleChange}
                                />
                                <span className="text-danger error-validation">{this.state.errors}</span>
                            </Col>
                        </Row>

                        

                        <Row className="form-group m-t-2-rem">
                            <Col md={{ size: 9 }}>
                                {
                                    this.state.errors.amount === "" || this.state.errors.amount === undefined ?
                                        <button className="btn btn-bg lightColor createButton" type="submit" >SUBMIT</button>
                                        :
                                        <button className="btn btn-bg lightColor createButton" type="submit" disabled>SUBMIT</button>
                                }
                                {/* <button className="btn btn-bg lightColor createButton" type="submit" >SUBMIT</button> */}
                                <button onClick={(e) => { e.preventDefault(); this.toggleModal(); }} className="btn btn-link">CANCEL</button>
                            </Col>
                        </Row>
                    </LocalForm>
                </ItemModal>
                <button className="btn customButton rightButton" style={{ borderRadius: '4px', backgroundColor: '#A7F6FF', color: '#082764' }} onClick={this.toggleModal}>
                    ADD ITEM
                </button>
            </React.Fragment>
        );
    }
}

export default AddItem